
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/pharmacy",
      function () {
        return require("private-next-pages/learn/pharmacy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/pharmacy"])
      });
    }
  